import { BlockchainIcon } from "~/components/logos/blockchain";
import { Copy } from "~/components/site/copy";
import { ExternalLink } from "~/components/site/external-link";
import type { BlockchainId } from "~/lib/stablecoins.server";

export type Contracts = Readonly<{
  chainId: BlockchainId;
  address: string;
  explorerAddress: string;
}>;

const contracts: Contracts[] = [
  {
    chainId: "ethereum",
    address: "0xf9FB20B8E097904f0aB7d12e9DbeE88f2dcd0F16",
    explorerAddress:
      "https://etherscan.io/token/0xf9FB20B8E097904f0aB7d12e9DbeE88f2dcd0F16",
  },
  {
    chainId: "avalanche",
    address: "0xf9FB20B8E097904f0aB7d12e9DbeE88f2dcd0F16",
    explorerAddress:
      "https://snowtrace.io/token/0xf9FB20B8E097904f0aB7d12e9DbeE88f2dcd0F16",
  },
  {
    chainId: "polygon",
    address: "0xfdcC3dd6671eaB0709A4C0f3F53De9a333d80798",
    explorerAddress:
      "https://polygonscan.com/token/0xfdcC3dd6671eaB0709A4C0f3F53De9a333d80798",
  },
  {
    chainId: "celo",
    address: "0xDE093684c796204224BC081f937aa059D903c52a",
    explorerAddress:
      "https://celoscan.io/token/0xDE093684c796204224BC081f937aa059D903c52a",
  },
  {
    chainId: "stellar",
    address: "GCQCNWT22JDLENQAVIE6DRJGHWAQ6EX2H5ABGPV55EJUPPZM5UA7KHZR",
    explorerAddress:
      "https://stellar.expert/explorer/public/asset/SBC-GCQCNWT22JDLENQAVIE6DRJGHWAQ6EX2H5ABGPV55EJUPPZM5UA7KHZR",
  },
  {
    chainId: "base",
    address: "0xfdcC3dd6671eaB0709A4C0f3F53De9a333d80798",
    explorerAddress:
      "https://basescan.org/token/0xfdcC3dd6671eaB0709A4C0f3F53De9a333d80798",
  },
  {
    chainId: "optimism",
    address: "0xf9FB20B8E097904f0aB7d12e9DbeE88f2dcd0F16",
    explorerAddress:
      "https://optimistic.etherscan.io/token/0xf9FB20B8E097904f0aB7d12e9DbeE88f2dcd0F16",
  },
  {
    chainId: "solana",
    address: "DBAzBUXaLj1qANCseUPZz4sp9F8d2sc78C4vKjhbTGMA",
    explorerAddress:
      "https://explorer.solana.com/address/DBAzBUXaLj1qANCseUPZz4sp9F8d2sc78C4vKjhbTGMA",
  },
  {
    chainId: "arbitrum",
    address: "0xfdcC3dd6671eaB0709A4C0f3F53De9a333d80798",
    explorerAddress:
      "https://arbiscan.io/token/0xfdcC3dd6671eaB0709A4C0f3F53De9a333d80798",
  },
];

type Props = Readonly<{
  selectedChainIds?: string[];
}>;

export function ContractList({
  selectedChainIds = [
    "ethereum",
    "avalanche",
    "polygon",
    "celo",
    "stellar",
    "base",
    "optimism",
    "solana",
    "arbitrum",
  ],
}: Props): JSX.Element {
  const filteredContracts = contracts.filter((c) =>
    selectedChainIds.includes(c.chainId)
  );

  return (
    <div className="border border-primary not-prose round bg-white dark:bg-black px-6 py-2 md:px-8 md:py-4 mt-8 mb-8 overflow-x-auto">
      <table className="table-auto w-full m-0">
        <tbody>
          {filteredContracts.map((c, i) => (
            <tr
              key={c.chainId}
              className={`block ${
                i !== filteredContracts.length - 1
                  ? "border-b border-primary "
                  : ""
              } py-4`}
            >
              <td
                className={`${
                  filteredContracts.length === 1 ? "" : "pl-4 "
                }pr-3`}
              >
                <BlockchainIcon chainId={c.chainId} />
              </td>
              <td className="pr-3">
                <ExternalLink
                  href={c.explorerAddress}
                  title="View Explorer"
                  className="text-black dark:text-white underline hover:no-underline"
                >
                  {c.address}
                </ExternalLink>
              </td>
              <td
                className={`w-full ${
                  filteredContracts.length === 1 ? "" : "pr-4"
                }`}
              >
                <Copy value={c.address} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
